import React, { useState, useEffect } from 'react';
import { Button, Card, Col, Container, Dropdown, Form, Row} from "react-bootstrap";
import { PencilIcon } from '@primer/octicons-react'
import { axiosAuth_IDENT_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import './AdminPages.css';
import configInfo from '../config/config.json';
import { translateAPIError } from '../utils/apiUtils';
import { formatDate } from '../utils/timeUtils';


const DeptAdminDetailsView = (props) => {

  // Utilities
  const { i18n, t } = useTranslation(['common', 'custom']);

  i18n.loadLanguages(['en']);
  i18n.loadLanguages(['zh_HK']);
  i18n.loadLanguages(['zh_CN']);

  // Initialize with actual JSON obj.  If not, will get error.
  const [deptAttrs, setDeptAttrs] = useState({
    id: null,
    deptCode: '',
    nameCode: '',
    name: '',
    nameLang2: '',
    nameLang3: '',
    deptType: '',
    description: '',
    creatorUsername: '',
    timeCreated: '',
    updaterUsername: '',
    timeUpdated: ''
  });

  const [currentDeptAttrs, setCurrentDeptAttrs] = useState({});

  const [deptList, setDeptList] = useState([]);

  // UI Functions

  // Initialize state
  useEffect(() => {

    if (props) {

      if (!props.objDetails.parentDeptId) {
        props.objDetails.parentDeptId = -1;
        props.objDetails.parentDisplayName['en']    = t("I18N_No_parent_dept", { lng: 'en' });
        props.objDetails.parentDisplayName['zh_HK'] = t("I18N_No_parent_dept", { lng: 'zh_HK' });
        props.objDetails.parentDisplayName['zh_CN'] = t("I18N_No_parent_dept", { lng: 'zh_CN' });
      }

      setDeptAttrs(props.objDetails);
      setCurrentDeptAttrs(props.objDetails);

      fetchDepts(props.objDetails.id);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);


  const fetchDepts = (currentDeptId) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.get("departments");

        resolve(res.data);

        if (res.status === 200) {

/*
          // Insert a value to represent no parent
          let newList = [{deptCode: "NONE",
                         id: 0}];
*/
/*
          let newList = [];

          for (let i=0; i<res.data.length; i++) {
            // Exclude self
            if (res.data[i].id !== currentDeptId) {

              res.data[i].displayName = [];
              res.data[i].displayName['en']    = res.data[i].name;
              res.data[i].displayName['zh_HK'] = res.data[i].nameLang2;
              res.data[i].displayName['zh_CN'] = res.data[i].nameLang3;

              newList.push(res.data[i]);
            }
          }

          // Insert a value to represent no parent
          let newNode = {deptCode: "NO_PARENT",
                         id: -1,
                         name: t("I18N_No_parent_dept", { lng: 'en' }),
                         nameLang2: t("I18N_No_parent_dept", { lng: 'zh_HK' }),
                         nameLang3: t("I18N_No_parent_dept", { lng: 'zh_CN' }),
                         displayName: []};

          newNode.displayName['en']    = t("I18N_No_parent_dept", { lng: 'en' });
          newNode.displayName['zh_HK'] = t("I18N_No_parent_dept", { lng: 'zh_HK' });
          newNode.displayName['zh_CN'] = t("I18N_No_parent_dept", { lng: 'zh_CN' });

          res.data.unshift (newNode);

          setDeptList(newList);
*/

          for (let i=0; i<res.data.length; i++) {
            res.data[i].displayName = [];
            res.data[i].displayName['en']    = res.data[i].name;
            res.data[i].displayName['zh_HK'] = res.data[i].nameLang2;
            res.data[i].displayName['zh_CN'] = res.data[i].nameLang3;
          }

          // Insert a value to represent no parent
          let newNode = {deptCode: "NO_PARENT",
                         id: -1,
                         name: t("I18N_No_parent_dept", { lng: 'en' }),
                         nameLang2: t("I18N_No_parent_dept", { lng: 'zh_HK' }),
                         nameLang3: t("I18N_No_parent_dept", { lng: 'zh_CN' }),
                         displayName: []};

          newNode.displayName['en']    = t("I18N_No_parent_dept", { lng: 'en' });
          newNode.displayName['zh_HK'] = t("I18N_No_parent_dept", { lng: 'zh_HK' });
          newNode.displayName['zh_CN'] = t("I18N_No_parent_dept", { lng: 'zh_CN' });

          res.data.unshift (newNode);

          setDeptList(res.data);
        }
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

  // View vs Edit Modes
  const [editMode, setEditMode] = useState(false);

  const [errMsg, setErrMsg] = useState('');


  const handleEditAttrs = (e) => {
    e.preventDefault();
    setEditMode(true);
  }


  const onAttrsInputChange = (e) => {
    setDeptAttrs({ ...deptAttrs, [e.target.name]: e.target.value })
  }


  const onDeptClick = (key, event) => {
    let dept = deptList.find(item => item.id === key);

    setDeptAttrs({ ...deptAttrs, parentDeptId: dept.id })
  };


  const handleEditCancel = (e) => {
    e.preventDefault();

    // Reset fields
    setDeptAttrs(currentDeptAttrs);

    setEditMode(false);
    setErrMsg('');
  }



  const handleEditSubmit = (e) => {
    e.preventDefault();

    if (!deptAttrs.deptCode || deptAttrs.deptCode.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_deptCode"));
    } else if (deptAttrs.deptCode.length > 30) {
      setErrMsg(t("I18N_ERR_Max_len_code") + 30);
    } else if (!deptAttrs.name || deptAttrs.name.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name"));
    } else if (deptAttrs.name.length > 100) {
      setErrMsg(t("I18N_Name") + " - " + t("I18N_ERR_Max_len") + "100");
    } else if (!deptAttrs.nameLang2 || deptAttrs.nameLang2.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name") + " (" + t("custom:I18N_Language_2") + ")");
    } else if (deptAttrs.nameLang2.length > 100) {
      setErrMsg(t("I18N_Name") + " (" + t("custom:I18N_Language_2") + ") - " + t("I18N_ERR_Max_len") + "100");
    } else if (!deptAttrs.nameLang3 || deptAttrs.nameLang3.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name") + " (" + t("custom:I18N_Language_3") + ")");
    } else if (deptAttrs.nameLang3.length > 100) {
      setErrMsg(t("I18N_Name") + " (" + t("custom:I18N_Language_3") + ") - " + t("I18N_ERR_Max_len") + "100");
    } else {
      validateNames();
      //validateOtherFields();
    }

    return;
  }

  // Since this is async, need to call this first, and check the others when username availability returns
  function validateNames() {

    new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.get("departments?currentDeptId=" + deptAttrs.id +
                                                       "&deptCodeExist="  + deptAttrs.deptCode +
                                                       "&nameExist="      + deptAttrs.name +
                                                       "&nameLang2Exist=" + deptAttrs.nameLang2 +
                                                       "&nameLang3Exist=" + deptAttrs.nameLang3);

        resolve(res.data);

        if ((res.status === 200) && (res.data.length > 0)) {
          // Dept code is taken
          setErrMsg(t("I18N_ERR_DeptName_taken"));
          return;
        } else {
          validateOtherFields();
          return;
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
          validateOtherFields();
        }
        return;
      }
    });
  }

  function validateOtherFields() {
    // Validate form inputs

    if (!deptAttrs.parentDeptId) {
      setErrMsg(t("I18N_ERR_Need_parent_dept"));
      return;
    }

    updateDept();
  }

  const updateDept = () => {

    const reqBody = deptAttrs;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.put("departments/" + deptAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {

          //setCurrentDeptAttrs(deptAttrs);
          refreshDeptAttrs(deptAttrs.id);

          // Restore UI to viewing mode
          setEditMode(false);
          setErrMsg('');
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });

  }


  const refreshDeptAttrs = (id) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.get("departments/" + id);

        resolve(res.data);

        if (res.status === 200) {

          res.data[0].parentDisplayName = [];
          res.data[0].parentDisplayName['en']    = res.data[0].parentDeptName;
          res.data[0].parentDisplayName['zh_HK'] = res.data[0].parentDeptNameLang2;
          res.data[0].parentDisplayName['zh_CN'] = res.data[0].parentDeptNameLang3;

          if (!res.data[0].parentDeptId) {
            res.data[0].parentDeptId = -1;
            res.data[0].parentDisplayName['en']    = t("I18N_No_parent_dept", { lng: 'en' });
            res.data[0].parentDisplayName['zh_HK'] = t("I18N_No_parent_dept", { lng: 'zh_HK' });
            res.data[0].parentDisplayName['zh_CN'] = t("I18N_No_parent_dept", { lng: 'zh_CN' });
          }

          setDeptAttrs(res.data[0]);
          setCurrentDeptAttrs(res.data[0]);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleClose = (e) => {
    e.preventDefault();

    // Return to list
    props.onUIMode('LIST')
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_Dept_Details")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Dept_info")}
            </span>
            {editMode ?
              null
              :
              <span style={{marginLeft:'15px', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}} onClick={handleEditAttrs}>
                <PencilIcon size={12} />
                {t("I18N_Edit")}
              </span>
            }
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          {editMode ?
            <Container>
              <form>
                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_Dept_code")}: *</Col>
                  <Col>{t("I18N_Name")} *:</Col>
                  { configInfo.uiConfig.visibleFields.DEPT_NameLang2 ?
                    <Col>{t("I18N_Name") + " (" + t("custom:I18N_Language_2") + ")"}: *</Col>
                  : null
                  }
                  { configInfo.uiConfig.visibleFields.DEPT_NameLang3 ?
                    <Col>{t("I18N_Name") + " (" + t("custom:I18N_Language_3") + ")"}: *</Col>
                  : null
                  }
                  { !configInfo.uiConfig.visibleFields.DEPT_NameLang2 ?
                    <Col></Col>
                  : null
                  }
                  { !configInfo.uiConfig.visibleFields.DEPT_NameLang3 ?
                    <Col></Col>
                  : null
                  }
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="deptCode" value={deptAttrs.deptCode}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="name" value={deptAttrs.name}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  { configInfo.uiConfig.visibleFields.DEPT_NameLang2 ?
                    <Col>
                      <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="nameLang2" value={deptAttrs.nameLang2}
                        onChange={(e) => onAttrsInputChange(e)} />
                    </Col>
                  : null
                  }
                  { configInfo.uiConfig.visibleFields.DEPT_NameLang3 ?
                    <Col>
                      <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="nameLang3" value={deptAttrs.nameLang3}
                        onChange={(e) => onAttrsInputChange(e)} />
                    </Col>
                  : null
                  }
                  { !configInfo.uiConfig.visibleFields.DEPT_NameLang2 ?
                    <Col></Col>
                  : null
                  }
                  { !configInfo.uiConfig.visibleFields.DEPT_NameLang3 ?
                    <Col></Col>
                  : null
                  }
                </Row>

                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col>{t("I18N_Parent_dept_name")}:</Col>
                  <Col>{t("I18N_Description")}:</Col>
                  <Col></Col>
                  <Col></Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <Dropdown>
                      <Dropdown.Toggle size="tiny_dropdown" variant="outline-secondary" className={classes.dropdown_item_wrap} id="dropdown-basic-button">
                        {!deptAttrs.parentDeptId ? t("common:I18N_DROPDOWN_PROMPT") :
                               deptList.find(item => item.id.toString() === deptAttrs.parentDeptId.toString()).displayName[i18n.language]}
                      </Dropdown.Toggle>

                      <Dropdown.Menu style={{ maxHeight: "300px", overflowY: "auto"}} id="dropdown-basic-button" >
                        {deptList.map((item, index) => {
                          return (
                            <Dropdown.Item key={index} eventKey={item.id} className={classes.dropdown_item_wrap} onClick={() => onDeptClick(item.id)}>
                              {item.displayName[i18n.language]}
                            </Dropdown.Item>
                          );
                        })}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>
                  <Col>
                    <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description" value={deptAttrs.description}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col></Col>
                  <Col></Col>
                </Row>

{/*
                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
                  <span>{t("I18N_Req_fields")}</span>
                </Row>
*/}

                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleEditCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ marginLeft: '15px' }}
                      onClick={handleEditSubmit}>
                      {t("I18N_Save")}
                    </Button>
                    <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                      {errMsg}
                    </span>
                  </div>
                </Row>
              </form>
            </Container>
            :
            <Container>
              <Row className={classes.admin_pages__field_label}>
                <Col>{t("I18N_Dept_code")}:</Col>
                <Col>{t("I18N_Name")}:</Col>
                { configInfo.uiConfig.visibleFields.DEPT_NameLang2 ?
                  <Col>{t("I18N_Name") + " (" + t("custom:I18N_Language_2") + ")"}: *</Col>
                : null
                }
                { configInfo.uiConfig.visibleFields.DEPT_NameLang3 ?
                  <Col>{t("I18N_Name") + " (" + t("custom:I18N_Language_3") + ")"}: *</Col>
                : null
                }
                { !configInfo.uiConfig.visibleFields.DEPT_NameLang2 ?
                  <Col></Col>
                : null
                }
                { !configInfo.uiConfig.visibleFields.DEPT_NameLang3 ?
                  <Col></Col>
                : null
                }
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col style={{minWidth:'60px', flexWrap: 'wrap', wordWrap: 'break-word'}}>{deptAttrs.deptCode}</Col>
                <Col style={{minWidth:'60px', flexWrap: 'wrap', wordWrap: 'break-word'}}>{deptAttrs.name}</Col>
                { configInfo.uiConfig.visibleFields.DEPT_NameLang2 ?
                  <Col style={{minWidth:'60px', flexWrap: 'wrap', wordWrap: 'break-word'}}>{deptAttrs.nameLang2}</Col>
                : null
                }
                { configInfo.uiConfig.visibleFields.DEPT_NameLang3 ?
                  <Col style={{minWidth:'60px', flexWrap: 'wrap', wordWrap: 'break-word'}}>{deptAttrs.nameLang3}</Col>
                : null
                }
                { !configInfo.uiConfig.visibleFields.DEPT_NameLang2 ?
                  <Col></Col>
                : null
                }
                { !configInfo.uiConfig.visibleFields.DEPT_NameLang3 ?
                  <Col></Col>
                : null
                }
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Parent_dept")}:</Col>
                <Col>{t("I18N_Description")}:</Col>
                <Col></Col>
                <Col></Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{(deptAttrs && deptAttrs.parentDisplayName) ? deptAttrs.parentDisplayName[i18n.language] : ''}</Col>
                <Col>
                  <textarea readOnly className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description" value={deptAttrs.description} />
                </Col>
                <Col></Col>
                <Col></Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Created_by")}:</Col>
                <Col>{t("I18N_Time_created")}:</Col>
                <Col>{t("I18N_Updated_by")}:</Col>
                <Col>{t("I18N_Time_updated")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col style={{overflowWrap:'anywhere'}}>{deptAttrs.creatorUsername}</Col>
                <Col>{formatDate(deptAttrs.timeCreated)}</Col>
                <Col style={{overflowWrap:'anywhere'}}>{deptAttrs.updaterUsername}</Col>
                <Col>{formatDate(deptAttrs.timeUpdated)}</Col>
              </Row>
            </Container>
          }
        </div>


        <hr className="solid" style={{ marginTop: '20px' }}></hr>

        <div className={classes.admin_pages__page_subtitle}>
          <Form.Group as={Row} className="mb-2 mt-2">
            <Col sm="2">
              <Button size="sm" variant="outline-secondary"
                style={{ fontSize: '12px', fontWeight: '300' }}
                onClick={handleClose}>
                {t("I18N_Close")}
              </Button>
            </Col>
{/*
            <Col sm="10">
              <span className={classes.admin_pages__field_label} style={{ color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                {updateRoleErrMsg}
              </span>
            </Col>
*/}
          </Form.Group>
        </div>

      </Card>
    </>
  );
}

export default DeptAdminDetailsView;
